// packages/eden-table/src/components/ColumnHiding/Context.jsx
import { createContext } from "react";
var ColumnHidingContext = createContext({
  hiddenColumns: [],
  columnDecorator: (column) => column
});
var Context_default = ColumnHidingContext;
export {
  Context_default as default
};
